export default {
  DOMAINS101: 'https://help.101domain.com/domain-management/name-servers-dns/modifying-name-servers-and-records' +
                '/changing-name-servers',
  GDOMAINS:  'https://support.google.com/domains/answer/3290309?hl=en',
  GODADDY:   'https://au.godaddy.com/help/change-nameservers-for-my-domains-664?',
  HOSTGATOR: 'https://www.hostgator.com/help/article/how-do-i-change-my-dns-or-name-servers',
  NAMECHEAP: 'https://www.namecheap.com/support/knowledgebase/article.aspx/767/10/how-to-change-dns-for-a-domain/',
  SITEGROUP: 'https://www.siteground.com/kb/how_to_change_my_ns_record/'
};